export const DIVS_SELECT = 'DIVS_SELECT';

export const divisionsSelect = ids => ({
  type: DIVS_SELECT,
  payload: { ids },
});
